<template>
  <div v-show="hasNextPage">
    <view-loader :padding-classes="'py-2'" v-if="loading"/>
    <b-button @click="$emit('nextPage')" variant="primary" size="sm" v-else>
      {{ $t('pages.checkins_detail.load_more') }}
      <Icon name="plus" width="16" vertical-align="sub"/>
    </b-button>
  </div>
</template>
<script>
import ViewLoader from "@/components/ViewLoader.vue";

export default {
  name: "PaginationInfinite",
  emits: ['nextPage'],
  components: {ViewLoader},
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    pagination: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasNextPage() {
      return this.pagination.page_number < this.pagination.num_pages
    }
  }
}
</script>


<style scoped>

</style>